import { apiRequest } from './api';

function getAuthHeaders() {
  try {
    const token = window.localStorage.getItem('chse_auth_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

function buildQueryString(params = {}) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.set(key, String(value));
    }
  });

  const query = searchParams.toString();
  return query ? `?${query}` : '';
}

function courseRequest(endpoint, params) {
  return apiRequest(`${endpoint}${buildQueryString(params)}`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}

export async function getCourses(params) {
  return courseRequest('/api/courses', params);
}

export async function getCoursesByCategory(params) {
  return courseRequest('/api/courses/by_category', params);
}

export async function getFreeCourses(params) {
  return courseRequest('/api/courses/free', params);
}

export async function getTopRatedCourses(params) {
  return courseRequest('/api/courses/top_rated', params);
}

export async function getNewLaunchesCourses(params) {
  return courseRequest('/api/courses/new_launches', params);
}

export async function getCoursesByFilter(params) {
  return courseRequest('/api/courses/filter', params);
}

export async function getCourseById(courseId) {
  return apiRequest(`/api/courses/${courseId}`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}

export async function getCourseChapters(courseId) {
  return apiRequest(`/api/courses/${courseId}/chapters`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}

export async function getCourseReviews(courseId) {
  return apiRequest(`/api/courses/${courseId}/reviews`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}
